import { ButtonLink, PlusIcon, Stack } from '@fukuri-admins/ui/common';
import { getCreatePushNotificationLink } from '~/utils/getLinks';
import styles from './emptyStyles.module.scss';

/**
 * プッシュ通知一覧 Empty 状態 Presentation
 *
 * プッシュ通知が 0 件のときに表示する
 */
export const PushNotificationListEmptyPresentation: React.FC = () => (
  <Stack
    gap={24}
    alignItems='center'
    justifyContent='center'
    height='100%'
    className={styles.container}
  >
    <p className={styles.message}>プッシュ通知が登録されていません</p>
    <ButtonLink
      variant='primary'
      size='md'
      icon={<PlusIcon size='xs' />}
      iconPosition='left'
      to={getCreatePushNotificationLink()}
    >
      新規作成
    </ButtonLink>
  </Stack>
);
